<template>
  <TheLoader v-if="loading"></TheLoader>
  <template v-else>
    <div v-if="showLoaderPopup" class="loader-modal">
      <TheLoader></TheLoader>
    </div>

    <div>
      <h1 class="title">
        <template v-if="basket.type === 'Bestelling'">{{$t('order')}}</template>
        <template v-else>{{$t('quote')}}</template>
        <span v-if="this.isAdmin" style="color: red"> [ADMIN]</span></h1>
      <div class="step-details">
        <h3>{{ $t('paymentForm.title') }}</h3>
        <span class="line"/>
        <span class="step">{{ $t('step') }} {{ getTotalSteps() }}</span>
      </div>
    </div>

    <div class="blocks">
      <div class="block-steps">
        <span class="step">{{ $t('step') }} {{ getTotalSteps() }}</span>
        <span class="line-vertical"/>
      </div>
      <div class="block-form">
        <h3 class="desktop">{{ $t('paymentForm.title') }}</h3>
        <div v-for="(paymentMethod, index) in paymentMethods">
          <div v-if="paymentMethod.options">
            <div v-for="option in paymentMethod.options" class="form-input radio"
                 @click="chosenPayment.method = option.id; resetIssuer(option)"
                 :style="(chosenPayment.method === option.id) ? 'background-color: var(--beige); border-color: var(--brown);' : ''">
              <div class="radio-name">
                <input type="radio" :id="option.id" name="paymentMethod" :value="option.id"
                       v-model="chosenPayment.method">
                <label :for="option.id">{{ option.name }}</label>
                <img :src="getPaymentImage(option.id)" :alt="option.name">
              </div>
              <select v-if="option.issuers && chosenPayment.method === option.id" v-model="chosenPayment.issuer" name=""
                      id="">
                <option value="">{{ $t('optionSelect') }}</option>
                <option v-for="dropdownOption in option.issuers" :value="dropdownOption.id">
                  {{ dropdownOption.name }}
                </option>
              </select>
            </div>
          </div>
          <div v-else>
            <div class="form-input radio"
                 @click="chosenPayment.method = index; resetIssuer(index)"
                 :style="(chosenPayment.method === index) ? 'background-color: var(--beige); border-color: var(--brown);' : ''">
              <div class="radio-name">
                <input type="radio" :id="index" name="paymentMethod" :value="index"
                       v-model="chosenPayment.method">
                <label :for="index">
                  {{ paymentMethod.name }}
                </label>
              </div>
              <div v-if="paymentMethod.description" class="payment-description">
                {{paymentMethod.description}}
              </div>
            </div>
          </div>
        </div>

        <BasketSummary v-if="basket.isCustom" :type="basket.type" :custom-rows="basket.customRows"
                       :valuta="basket.valuta" :total-excl="basket.customExcl" :total-incl="basket.customIncl"
                       :vat-percentage="basket.vatPercentage" :total-vat="basket.customVat"
                       :hide-prices="basket.hidePrices"
        ></BasketSummary>
        <BasketSummary v-else :type="basket.type" :contact-form="contactForm" :delivery-form="deliveryForm"
                       :pickup-form="(this.hasPptMove) ? pickupForm : null" :products="basket.products"
                       :total-excl="basket.totalExcl" :total-excl-benb="basket.totalExclNoShipping"
                       :vat-percentage="basket.vatPercentage" :total-vat="basket.totalVat"
                       :total-vat-benb="basket.totalVatNoShipping" :kwantum-korting-excl="basket.kwantumKortingExcl"
                       :dealer-row="basket.dealerRow" :dealer-amount="basket.dealerAmount"
                       :totalIncl="basket.totalIncl" :total-incl-benb="basket.totalInclNoShipping"
                       :shipping-costs="basket.shippingCostsExcl" :hide-prices="basket.hidePrices"
        ></BasketSummary>

        <div class="nav-btns">
          <button v-if="!paymentChosen" disabled class="gsd-btn gsd-btn-secondary">
            {{ $t('paymentForm.selectPaymentBtn') }}
          </button>
          <button v-else-if="!paymentOnline" @click="placeOrder()" class="gsd-btn gsd-btn-secondary">
            {{ $t('paymentForm.placeOrder') }}
          </button>
          <button v-else @click="placeOrder()" class="gsd-btn gsd-btn-secondary">{{ $t('paymentForm.placeAndPay') }}
          </button>

          <router-link :to="{ name: 'delivery-details' }" class="gsd-btn gsd-btn-tertiary">
            <svg xmlns="http://www.w3.org/2000/svg" height="1.2em" viewBox="0 0 512 512" fill="currentcolor">
              <path
                  d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288 480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z"/>
            </svg>
            {{ $t('back') }}
          </router-link>
        </div>
      </div>
      <div class="block-right">
        <BasketSummary v-if="basket.isCustom" :type="basket.type" :custom-rows="basket.customRows"
                       :valuta="basket.valuta" :total-excl="basket.customExcl" :total-incl="basket.customIncl"
                       :vat-percentage="basket.vatPercentage" :total-vat="basket.customVat"
                       :is-pickup="hasPptMove" :show-shipping="true" :hide-prices="basket.hidePrices"
        ></BasketSummary>
        <BasketSummary v-else :type="basket.type" :contact-form="contactForm" :delivery-form="deliveryForm"
                       :pickup-form="(this.hasPptMove) ? pickupForm : null" :products="basket.products"
                       :total-excl="basket.totalExcl"
                       :vat-percentage="basket.vatPercentage"
                       :total-vat="basket.totalVat"
                       :kwantum-korting-excl="basket.kwantumKortingExcl" :dealer-row="basket.dealerRow"
                       :dealer-amount="basket.dealerAmount"
                       :totalIncl="basket.totalIncl" :shipping-costs="basket.shippingCostsExcl"
                       :is-pickup="hasPptMove" :show-shipping="true" :hide-prices="basket.hidePrices"
        ></BasketSummary>
      </div>
    </div>
  </template>
</template>

<script>
import axios from 'axios';
import BasketSummary from "../components/BasketSummary.vue";
import TheLoader from "../components/general/TheLoader.vue";

export default {
  name: "DeliveryDetails",
  components: {TheLoader, BasketSummary},
  data() {
    return {
      public: public_dir, //deze mag niet hetzelfde heten, anders pikt ie t niet in de productie build
      icons: frontend_dir + '/icons/',
      step: 3,
      totalSteps: 3,
      basket: {},
      form: {},
      chosenPayment: {
        method: '',
        issuer: '',
      },
      contactForm: {},
      deliveryForm: {},
      pickupForm: {},
      hasPptMove: false,
      disableNextStep: false,
      paymentMethods: [],
      isAdmin: false,
      loading: true,
      showLoaderPopup: false,
    };
  },
  async mounted() {
    try {
      await this.getBasket();
      await this.getForm('contact');
      await this.getForm('delivery');
      await this.getForm('pickup');
      await this.getPaymentMethods();
    } catch (e) {
      this.$handleError(e);
    } finally {
      this.loading = false;
      this.form.firstVisit = true;
    }
  },
  computed: {
    paymentChosen() {
      let chosen = false;

      let method = this.chosenPayment.method;
      if (method && method !== '') {
        let mollieOptions = this.paymentMethods?.mollie?.options;
        if (mollieOptions && mollieOptions.some((obj) => obj.id.toUpperCase() === method.toUpperCase())) { // mollie opties?
          Object.keys(mollieOptions).forEach((index) => {
            if (mollieOptions[index].id.toUpperCase() === this.chosenPayment.method?.toUpperCase()) { // huidige keuze
              if (mollieOptions[index]?.issuers) { // issuer opties?
                if (mollieOptions[index]?.issuers.some((obj) => obj.id.toUpperCase() === this.chosenPayment.issuer.toUpperCase()) && this.chosenPayment.issuer && this.chosenPayment.issuer !== '') {
                  chosen = true;
                }
              }
              else {
                chosen = true;
              }
            }
          })
        }
        else {
          chosen = true;
        }
      }

      return chosen;
    },
    paymentOnline() {
      return this.paymentMethods?.mollie?.options.some(obj => obj.id.toUpperCase() === this.chosenPayment.method?.toUpperCase());
    }
  },
  methods: {
    async getBasket() {

      try {
        const response = await axios.get(`/${this.$sessionLang}/api/getbasket`);

        this.basket = response.data.data.basket;
        this.hasPptMove = response.data.data.hasPptMove;
        if (this.basket.paymentmethod) {
          this.chosenPayment.method = this.basket.paymentmethod;
        }
      } catch (error) {
        this.$handleError(error);
      }
    },
    async getForm(formStep) {
      try {
        const response = await axios.post(`/${this.$sessionLang}/api/getform`, {
          step: formStep,
        });

        if (!response.data.data.hasProducts) {
          this.$router.push({name: 'basket'});
          return;
        }

        if (formStep == 'contact') {
          this.contactForm = response.data.data.form;
        }
        else if (formStep == 'delivery') {
          this.deliveryForm = response.data.data.form;
        }
        else if (formStep == 'pickup') {
          this.pickupForm = response.data.data.form;
        }

        this.isAdmin = response.data.data.isAdmin;
        this.disableNextStep = (!this.form.firstVisit && this.hasErrors());
      } catch (error) {
        this.$handleError(error);
      }
    },
    async getPaymentMethods() {
      try {

        let response = await axios.get(`/${this.$sessionLang}/api/getpaymentmethods`);

        this.paymentMethods = response.data.data;
        if (Object.keys(this.paymentMethods).length == 1) {
          this.chosenPayment.method = this.paymentMethods[Object.keys(this.paymentMethods)].name;
        }
      } catch (error) {
        this.$handleError(error);
      }
    },
    hasErrors() {
      let hasErrors = false;
      if (this.form.errors && Object.keys(this.form.errors).length > 0) {
        hasErrors = true;
      }

      return hasErrors;
    },
    getTotalSteps() {
      let totalSteps = 3;
      if (this.hasPptMove) {
        totalSteps = 4;
        this.step = 4;
      }

      return this.step + '/' + totalSteps;
    },
    nextStep(step) {
      this.form.firstVisit = false;
      this.updateForm('pickup');

      if (!this.hasErrors()) {
        this.$router.push({name: step});
      }
      else {
        this.disableNextStep = true;
      }
    },
    async placeOrder() {
      this.showLoaderPopup = true;

      try {

        let response = await axios.post(`/${this.$sessionLang}/api/placeorder`, {
          paymentMethod: this.chosenPayment.method,
          issuer: this.chosenPayment.issuer,
          type: 'bestelling',
        });

        if (response.data.data.redirect) {
          if (response.data.data.dataLayer?.length > 0) {
            let dataLayer = window.dataLayer || [];
            dataLayer.push({"ecommerce": null});
            dataLayer.push(response.data.data.dataLayer);
          }
          window.location.href = response.data.data.redirect;
        }

      } catch (error) {
        this.$handleError(error);
      }
    },
    resetIssuer(option) {
      let resetIssuer = false;
      if (this.chosenPayment.issuer !== '') { // issuer gekozen
        if (option?.issuers) { // huidige method heeft issuers
          resetIssuer = !option.issuers.some((obj) => obj.id === this.chosenPayment.issuer);
        }
      }

      if (resetIssuer) {
        this.chosenPayment.issuer = '';
      }
    },
    getPaymentImage(paymentId) {
      return this.icons + paymentId + '.svg';
    }
  },
}
</script>

<style scoped>
.loader-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8); /* Semi-transparent white background */
  z-index: 9999;
}


.title {
  margin-bottom: 1em;
}

h3 {
  font: var(--bold-22-28);
}

.step-details {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}

.line {
  background-color: var(--light-brown);
  height: 2px;
  border: none;
  opacity: 0.6;
  flex-grow: 1;
}

.step {
  font: var(--bold-10);
  color: var(--white);
  background-color: var(--black);
  padding: 5px;
  border-radius: 16px;
  text-align: center;
}

.form-input {
  font: var(--bold-16-20);
  line-height: 28px;
  margin-bottom: 15px;
}

.form-input input {
  padding: 8px;
  opacity: 1;
}

.form-input input:focus {
  outline-color: var(--brown);
}

.form-input select {
  opacity: 1;
}

.form-input.checkbox {
  display: flex;
  gap: 8px;
  font: var(--medium-16);
}

.form-input.checkbox input {
  max-width: 20px;
  max-height: 20px;
  color: #C9C9CC;
  accent-color: var(--brown);
}

.form-input.checkbox.txtsmall {
  font: var(--medium-14);
}

.form-input.radio {
  flex-direction: column;
  align-items: center;
  border: 1px solid #C9C9CC;
  border-radius: 8px;
  padding: 14px;
  gap: 12px;
}

.radio-name {
  align-self: flex-start;
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
}

.form-input.radio img {
  height: 24px;
}

.form-input.radio input {
  max-width: 16px;
  accent-color: var(--brown);
}

.form-input.radio input:focus {
  background-color: var(--beige);
}

.gsd-btn {
  width: 100%;
  font: var(--bold-16-20);
}

a.gsd-btn {
  border: none;
  display: flex;
  justify-content: center;
  gap: 5px;
  padding: 0;
}

a.gsd-btn:hover:not(:disabled) {
  background-color: inherit;
  border: inherit;
  text-decoration: none;
  color: var(--orange);
}

.gsd-btn-secondary {
  margin: 20px 0;
}

.form-input a {
  color: var(--brown);
  text-decoration: underline;
}

.form-input a:hover {
  color: var(--orange);
}

.summary {
  margin-top: 40px;
  padding: 24px;
  background-color: #F7F7F7;
  border-radius: 8px;
}

.even-row {
  display: flex;
  justify-content: space-between;
  font: var(--medium-14);
  padding: 10px 0;
}

.even-row .quantity {
  color: var(--brown);
}

.even-row.btw,
.even-row.subtotal {
  border-top: 1px solid #C9C9CC;
}

.even-row.subtotal {
  padding-bottom: 0;
}

.even-row.shipping {
  padding-top: 0;
}

.even-row.total {
  font: var(--medium-22);
  border-top: 1px solid #C9C9CC;
  padding-top: 15px;
}


.btn-split {
  display: flex;
  flex-direction: column-reverse;
  gap: 8px;
  margin-bottom: 35px;
}

.nav-btns .gsd-btn {
  margin: 10px 0 0 0;
}

.desktop,
.block-steps,
.block-right {
  display: none;
}

@media (min-width: 1140px) {
  .title {
    font: var(--bold-40-52);
  }

  h3 {
    font: var(--bold-32);
  }

  .step-details {
    display: none;
  }

  .blocks {
    display: flex;
    gap: 32px;
  }

  .block-steps {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 55px;
    gap: 8px;
  }

  .line-vertical {
    background-color: var(--light-brown);
    width: 2px;
    border: none;
    opacity: 0.6;
    flex-grow: 1;
  }

  .block-form {
    flex-grow: 1;
  }

  .block-form > h3 {
    margin-bottom: 24px;
  }

  .block-form .summary {
    display: none;
  }

  .block-form .payment-description {
    font: var(--normal-14-17);
    padding-left: 24px;
  }

  .summary {
    margin-top: 0;
    max-width: 450px;
  }

  .desktop,
  .block-right {
    display: inline-block;
  }

  .block-right {
    min-width: 440px;
    position: sticky;
    top: 90px;
    margin-left: auto;
    align-self: flex-start;
  }

  .nav-btns {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: space-between;
  }

  .nav-btns .gsd-btn {
    width: auto;
    margin: 20px 0 0 0;
  }

  .btn-split {
    flex-direction: row;
    margin-bottom: 0;
    gap: 8px;
  }

}

</style>